"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M8.64725 8.07426L7.71404 9.24116C6.26797 8.39154 5.06296 7.18654 4.21334 5.74048L5.38024 4.80727C5.51703 4.69781 5.6137 4.54611 5.65515 4.37589C5.6966 4.20567 5.68049 4.02652 5.60934 3.86642L4.54554 1.47078C4.46925 1.29911 4.33447 1.16011 4.16523 1.07857C3.99599 0.997028 3.80329 0.978241 3.62149 1.02556L1.59621 1.5502C1.40731 1.59973 1.24309 1.71674 1.1346 1.87913C1.02612 2.04151 0.980869 2.23801 1.00742 2.43148C1.36275 4.96209 2.53232 7.30823 4.3393 9.1152C6.14627 10.9222 8.49243 12.0917 11.0231 12.4471C11.2165 12.4737 11.4129 12.4285 11.5752 12.32C11.7375 12.2115 11.8544 12.0472 11.9036 11.8583L12.429 9.83377C12.4763 9.65197 12.4575 9.45927 12.376 9.29003C12.2944 9.12079 12.1554 8.98601 11.9838 8.90972L9.5881 7.84593C9.42804 7.77496 9.24901 7.75887 9.07886 7.80016C8.90871 7.84146 8.75698 7.93782 8.64725 8.07426V8.07426Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

exports.default = Icon;